import './navBar.css';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { shallow } from 'zustand/shallow';
import { useInitDataStore } from '../../../store/initData.store';
import { useItemsStore } from '../../../store/items.store';
import { useAuthStore } from '../../../store/authStore.storage';
import { GetInitDataService } from '../../services/getInitData.service';
import SelectField from '../Inputs/inputSelectField';
import AppGetIcon from '../AppGetIcon';
import ProgressBar from '../ProgressBar';
import { useAuth } from '../../../contexts/AuthContext';
import AppNavbarDropdown from './AppNavbarDropdown';
import AppAvatar from '../AppAvatar';

// 👇 NUEVO: import del switcher
import ThemeSwitcher from '../ThemeSwitcher';
// (si creaste index.css del switcher) import '../ThemeSwitcher/index.css';

const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);
  const { logout } = useAuth();

  const dataAuthStore = useAuthStore((state) => ({ logout: state.logout }), shallow);
  const dataItemsStorage = useItemsStore((state) => ({ items: state.items, setItems: state.setItems }), shallow);
  const dataInitDataStore = useInitDataStore(
    (state) => ({
      user: state.initData?.user,
      userRoles: state.initData?.userRoles?.map(item => ({ value: String(item?.id), label: String(item?.role.name) })) || [],
      rolSelected: state.rolSelected,
      setRolSelected: state.setRolSelected,
      facultySelected: state.facultySelected,
      setFacultySelected: state.setFacultySelected,
      setInitData: state.setInitData,
    }),
    shallow
  );

  const handleSelectRole = async (value: string) => {
    setLoading(true);
    dataInitDataStore.setRolSelected(Number(value));
    let response: any = await GetInitDataService();
    if (response && response.items && response.items[0] && response.items[0].children) {
      await dataInitDataStore.setInitData(response);
      await dataItemsStorage.setItems(response.items);
      let route = response.items[0]?.children?.[0]?.route;
      navigate(route, { replace: true });
    } else {
      console.error("Estructura de respuesta no válida", response);
    }
    setLoading(false);
  };

  const signOut = async () => {
    setLoading(true);
    await logout();
    setLoading(false);
  };

  return (
    <div className="navbar">
      {loading && (
        <div className="navbar-loading-overlay">
          <ProgressBar />
        </div>
      )}

      <div className="navbar-content">
        <div className="navbar-controls">
          <div className='divider'/>

          {/* Selector de rol */}
          {dataInitDataStore.userRoles.length > 0 && (
            <div className="navbar-dropdown">
              <AppNavbarDropdown
                itemName="Rol"
                options={dataInitDataStore.userRoles}
                modelValue={String(dataInitDataStore?.userRoles[0]?.value)}
                onUpdate={handleSelectRole}
              />
            </div>
          )}

          {/* 👇 Switch de tema fuera del sidebar */}
          <div className="navbar-theme">
            <ThemeSwitcher withShortcutHint />
          </div>

          {/* Perfil / Avatar */}
          <div className="navbar-profile" onClick={() => setActiveMenu(!activeMenu)}>
            <AppAvatar
              avatar={dataInitDataStore.user?.avatarUrl}
              name={dataInitDataStore.user?.name}
              size="sm"
            />
          </div>
        </div>
      </div>

      {/* Overlay */}
      {activeMenu && (
        <div className="navbar-overlay" onClick={() => setActiveMenu(false)} />
      )}

      {/* Menú de usuario */}
      {activeMenu && (
        <div className="navbar-user-menu">
          <div className="navbar-user-menu-header">{dataInitDataStore.user?.name}</div>
          <div className="navbar-user-menu-items">

            {/* 👇 Opción Apariencia dentro del menú */}
            <div className="navbar-user-menu-item">
              <ThemeSwitcher showLabel />
            </div>

            <button
              className="navbar-user-menu-item"
              onClick={signOut}
              disabled={loading}
            >
              {loading ? 'Cerrando sesión...' : 'Cerrar sesión'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavBar;
